/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  EmployeeLeaves,
  ProfileNotifications
} from '../../schema'


/**
 * List all Leaves of an employee
 */
export const listEmployeeLeaves = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmployeeLeaves[]>> => {
    return axios.get(
      `/empleaves/`,options
    );
  }


export const getListEmployeeLeavesQueryKey = () => [`/empleaves/`];

    
export type ListEmployeeLeavesQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployeeLeaves>>>
export type ListEmployeeLeavesQueryError = AxiosError<unknown>

export const useListEmployeeLeaves = <TData = Awaited<ReturnType<typeof listEmployeeLeaves>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmployeeLeaves>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEmployeeLeavesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployeeLeaves>>> = ({ signal }) => listEmployeeLeaves({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listEmployeeLeaves>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * List all notifications
 */
export const listProfileNotifications = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ProfileNotifications[]>> => {
    return axios.get(
      `/profile-notif/`,options
    );
  }


export const getListProfileNotificationsQueryKey = () => [`/profile-notif/`];

    
export type ListProfileNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listProfileNotifications>>>
export type ListProfileNotificationsQueryError = AxiosError<unknown>

export const useListProfileNotifications = <TData = Awaited<ReturnType<typeof listProfileNotifications>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProfileNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProfileNotificationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfileNotifications>>> = ({ signal }) => listProfileNotifications({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listProfileNotifications>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

